import React from 'react';
import { BOX_SHADOW_UNDIRECTED } from '~/Constants/CSS.constants';
import { BORDER_COLOR, WHITE } from '~/Constants/Colors.constants';
import { Button, Typography } from '~/UIKit';
import { IItemCreationListItem } from './ItemCreationListItem.models';
import { KeyboardArrowRight } from '@mui/icons-material';
import { makeStyles } from '~/UIKit/Style';
import classNames from 'classnames';

interface IItemCreationPickerProps {
  listItems: IItemCreationListItem[];
  className?: string;
}

const useStyles = makeStyles(
  (theme) => ({
    body: {
      margin: '7px 15px',
      [theme.breakpoints.up('md')]: {
        margin: '23px 40px',
      },
    },
    cardContainer: {
      overflow: 'auto',
    },
    card: {
      border: `thin solid ${BORDER_COLOR}`,
      borderRadius: 3,
      backgroundColor: WHITE,
      boxShadow: BOX_SHADOW_UNDIRECTED,
      padding: 15,
      margin: '7px 0',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        maxWidth: 600,
      },
    },
    disabled: {
      opacity: 0.35,
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      placeContent: 'center',
      height: 63,
      width: 57,
      '& .MuiSvgIcon-root': {
        width: '100%',
        height: 'auto',
      },
    },
    content: {
      flex: 1,
      padding: '0 15px',
      overflowWrap: 'break-word',
    },
    contentTitle: {
      fontWeight: 'bold',
      fontSize: '16px',
      lineHeight: '20px',
    },
    contentDescription: {
      fontSize: '14px',
      letterSpacing: 0.44,
      lineHeight: '20px',
    },
    arrow: {
      marginRight: '-8px',
      color: BORDER_COLOR,
      fontSize: 26,
    },
  }),
  { name: 'ItemCreationPicker' },
);

export const ItemCreationPicker = ({ listItems, className }: IItemCreationPickerProps) => {
  const { classes } = useStyles();

  return (
    <div className={className ?? classes.body}>
      {listItems.map((item, index) => (
        <article key={`test_${index}`} className={classes.cardContainer}>
          <Button
            className={classNames(classes.card, {
              [classes.disabled]: item.disabled,
            })}
            onClick={item.disabled ? () => {} : item.onClick}
            disabled={item.disabled}
            data-testid={item.testId}
          >
            <div className={classes.icon}>{item.icon}</div>
            <div className={classes.content}>
              <Typography className={classes.contentTitle}>{item.title}</Typography>
              <Typography
                className={classes.contentDescription}
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>
            <KeyboardArrowRight className={classes.arrow} />
          </Button>
        </article>
      ))}
    </div>
  );
};
